import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { DxDataGridComponent } from 'devextreme-angular';
import ArrayStore from 'devextreme/data/array_store';
import { NotificationService } from 'src/app/common/component/notification/notification.service';
import { BatchReportsGridEvent, JobDetail, JobGroup, reportParametersConfig } from './batch-reports-grid-types';
import { BatchReportsService} from './batch-reports-service';


@Component({
  selector: 'app-batch-reports-grid',
  templateUrl: './batch-reports-grid.component.html',
  styleUrls: ['./batch-reports-grid.component.scss']
})
export class BatchReportsGridComponent implements OnInit {

  @Input()
  reportType: string;

  @Input()
  pageSize: number;

  @Output() batchGridEvent = new EventEmitter<BatchReportsGridEvent>(); 

  jobGroups: ArrayStore;
  actualPageSize: number = 5;
  prevSelectedRowKey: string = '';

  reqParamsPopupVisible: boolean = false;
  requestParamsData: Array<any> = [];
  reqParamsDataGrid; 


  @ViewChild('batchReportsGrid', { static: false }) dataGrid: DxDataGridComponent;

  constructor(private batchReportsService: BatchReportsService, 
    private notificationService: NotificationService,
    private changeDetectorRef: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.getUserJobInfo();
  }

  ngAfterViewInit(): void {

    if(this.pageSize){
      this.actualPageSize = this.pageSize;
    }

    this.dataGrid.instance.beginCustomLoading("");
  }

  getUserJobInfo(){
    this.batchReportsService.getUserJobInfo(this.reportType).subscribe({
      next: async jobGroupsData => {

        this.jobGroups = new ArrayStore({
          data: this.processJobGroupsData(jobGroupsData),
          key: 'reportRefID',
        });

        this.batchReportsService.setJobGroupArrayStore(this.jobGroups);
        
        this.dataGrid.instance.endCustomLoading();  

      },
      error: (error: any) => {
        this.dataGrid.instance.endCustomLoading();
        this.notificationService.alert("error", "Error while fetching Batch Reports data", error);
      }
    });
  }

  processJobGroupsData(jobGroupsData: JobGroup[]){

    let jobDetails = new Array<JobDetail>();
    let reportSubTypes: string[] = new Array<string>();
    let jobStatusMap = new Map<string,number>();

    jobGroupsData.forEach((jobGroup,i) => {
      
      reportSubTypes = [];
      jobStatusMap.clear();

      //1. In API response, the reportRefID is at level-0. Add the reportRefID to each job detail. This is required to render the detail grid.
      //2. As we iterate, gather the report sub types, they will be displayed under "Request Reports" column.
      //3. As we iterate, gather the job statuses in a map, they will be displayed under "Status Summary" column.
      jobGroup.jobs.forEach(job => {
        let jobDetail = new JobDetail();        
        
        //Convert UTC to Local Time
        job.requestedDateTime = new Date(job.requestedDateTime + 'Z');
        job.lastUpdateDateTime = new Date(job.lastUpdateDateTime + 'Z');

        jobDetail = {reportRefID: jobGroup.reportRefID, ...job}
        jobDetails.push(jobDetail);

        reportSubTypes.push("".concat('"',job.reportSubType,'"'));
        let count = jobStatusMap.get(job.status);
        count? jobStatusMap.set(job.status,++count): jobStatusMap.set(job.status,1);
        
      });      

      jobGroupsData[i].reportSubTypes = reportSubTypes.join(', ');

      jobStatusMap.set('total',jobGroupsData[i].jobs.length);      

      jobGroupsData[i].statusSummary = this.batchReportsService.getStatusSummary(jobStatusMap);

      //Convert UTC to Local Time
      jobGroupsData[i].requestedDateTime = new Date(jobGroupsData[i].requestedDateTime + 'Z');
    });

    this.batchReportsService.setJobDetails(jobDetails);
    return jobGroupsData;
  }

  //Close all expanded rows. Allow only 1 row to be expanded anytime. 
  onRowExpanding(e){
    e.component.collapseAll(-1);
  }

  onRowClicked(e){

    if(e.key == this.prevSelectedRowKey){ //if same row was clicked
      if(e.isExpanded){ //if the row is already expanded, then collapse it.
        e.component.collapseAll(-1);
      }else{ //otherwise expand it.
        e.component.expandRow(e.key);
      }            
    }else{ //if diff row was clicked, close prev open row and expand this row.
      e.component.collapseAll(-1);
      e.component.expandRow(e.key);
    }

    this.prevSelectedRowKey = e.key;
  }

  async onViewClicked(cellInfo){    
    
    if(this.disableViewReport(cellInfo)) return false;

    let event = new BatchReportsGridEvent();    

    event.subject = "report";
    event.eventType = "view_all_reports";

    let query = this.batchReportsService.getJobDetailsArrayStore().createQuery();
    let jobs = query.filter(item => item.reportRefID == cellInfo.data.reportRefID).toArray();
    event.data = {jobs: jobs};

    this.batchGridEvent.emit(event);

    this.dataGrid.instance.collapseAll(-1);
    return false;
  }

  onViewReqParamsClicked(cellInfo){

    let apiBody = JSON.parse(cellInfo.data.apiBody);

    if(typeof apiBody == 'string') apiBody = JSON.parse(apiBody);

    this.requestParamsData = this.prepareReqParams(apiBody);

    this.reqParamsPopupVisible = true;
  }

  prepareReqParams(apiBody: Object): Array<any>{

    let reportParamConfig = reportParametersConfig.filter(item => item.reportType == this.reportType)[0];
    reportParamConfig.paramConfig.sort((a,b) => a.displayOrder - b.displayOrder);

    let reportParamData = [];
    
    reportParamConfig.paramConfig.forEach(config => {
      let value = apiBody[config.paramName];

      if(typeof value != 'string' && typeof value != 'boolean'){
        if(Array.isArray(value)) value = value.join(',');
        else value = JSON.stringify(value);
      }

      reportParamData.push({
        paramName: config.displayName,
        paramValue: value
      });
    });

    return reportParamData;

  }

  onReqParamGridReady(e){
    if(!this.reqParamsDataGrid) this.reqParamsDataGrid = e.component.instance();
  }

  onPopupShowing($event){
    if(this.reqParamsDataGrid) this.reqParamsDataGrid.pageIndex(0);
  }

  disableViewReport(cellInfo){
    let statusSummary: string = cellInfo.data.statusSummary;    
    if(statusSummary.includes('submitted') || statusSummary.includes('in progress')) return true;    
    return false;
  }

}
